import React, { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Cookies from "js-cookie";

export const POPUP_COOKIE = "ic_campaign_popup_seen";

// Campaign invitation shown on the first visit of the day; the cookie
// suppresses it for 24h from when it was shown.
function CampaignPopup({ config }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!Cookies.get(POPUP_COOKIE)) {
      setOpen(true);
      Cookies.set(POPUP_COOKIE, "1", { expires: 1 });
    }
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} className="relative z-[60]">
      <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="relative w-full max-w-md overflow-hidden rounded-lg bg-white shadow-xl">
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label="Close"
            className="absolute right-3 top-3 z-10 rounded-full bg-black/40 p-1 text-white hover:bg-black/60"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
          {config.popup_image_url && (
            <img
              src={config.popup_image_url}
              alt={config.popup_headline || "Annual campaign"}
              className="max-h-72 w-full object-cover"
            />
          )}
          <div className="p-6 text-center">
            <Dialog.Title className="text-2xl font-extrabold text-primaryDark">
              {config.popup_headline || "Please partner with Inside Chassidus"}
            </Dialog.Title>
            {config.popup_text && (
              <p className="mt-2 whitespace-pre-line text-primaryDark">{config.popup_text}</p>
            )}
            <a
              href={config.donate_url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-5 inline-block rounded bg-[#d9534f] px-8 py-2.5 text-lg font-bold text-white transition-colors hover:bg-[#c9302c]"
            >
              Please Donate
            </a>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default CampaignPopup;
